import { z } from 'zod';
import { documentDefaultValue, documentOptionalSchema, getDocumentSchema } from '../../../constants/sharedSchemas';

export const agreementsSchema = {
  required: z.object({
    conditionsParticipationDocument: getDocumentSchema('Conditions of Participation'),
    feeTransparencyAcknowledgmentDocument: getDocumentSchema('Fee transparency acknowledgment'),
    medicalReleaseDocument: getDocumentSchema('Medical release document'),
    permissionForTravelOptionalDocument: documentOptionalSchema,
    doublePlacementPermissionDocument: getDocumentSchema('Double Placement Permission'),
    singleHostPermissionDocument: getDocumentSchema('Single Host Permission'),
  }),
  optional: z.object({
    conditionsParticipationDocument: documentOptionalSchema,
    feeTransparencyAcknowledgmentDocument: documentOptionalSchema,
    medicalReleaseDocument: documentOptionalSchema,
    permissionForTravelOptionalDocument: documentOptionalSchema,
    doublePlacementPermissionDocument: documentOptionalSchema,
    singleHostPermissionDocument: documentOptionalSchema,
  }),
};

export type AgreementsFormValues = z.infer<(typeof agreementsSchema)['required']> | z.infer<(typeof agreementsSchema)['optional']>;

export const defaultValues: AgreementsFormValues = {
  conditionsParticipationDocument: documentDefaultValue,
  feeTransparencyAcknowledgmentDocument: documentDefaultValue,
  medicalReleaseDocument: documentDefaultValue,
  permissionForTravelOptionalDocument: documentDefaultValue,
  doublePlacementPermissionDocument: documentDefaultValue,
  singleHostPermissionDocument: documentDefaultValue,
};
